/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetVitaLatestDocumentQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetVitaLatestDocumentQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    vitaLatestDocument?:
      | { __typename?: 'VitaCoverLetter' }
      | {
          __typename?: 'VitaDocument';
          language?: Types.VitaDocumentLanguage | null;
          token?: string | null;
          id?: string | null;
          cv?: {
            __typename?: 'VitaDocumentCV';
            aboutMe?: string | null;
            personalInformation?: {
              __typename?: 'VitaDocumentCVPersonalInformation';
              firstName?: string | null;
              lastName?: string | null;
              phone?: string | null;
              email?: string | null;
              city?: string | null;
              zip?: string | null;
              street?: string | null;
              country?: string | null;
              birthdate?: string | null;
              birthplace?: string | null;
            } | null;
            professionalExperience?: Array<{
              __typename?: 'VitaDocumentCVProfessionalExperience';
              company?: string | null;
              occupation?: string | null;
              startDate?: string | null;
              endDate?: string | null;
              isCurrentEmployer?: boolean | null;
              descriptions?: Array<{
                __typename?: 'VitaDocumentCVProfessionalExperienceDescription';
                description?: string | null;
              } | null> | null;
              industry?: {
                __typename?: 'VitaDocumentCVProfessionalExperienceIndustry';
                id?: string | null;
                value?: string | null;
              } | null;
              jobLevel?: {
                __typename?: 'VitaDocumentCVProfessionalExperienceJobLevel';
                id?: string | null;
                value?: string | null;
              } | null;
              discipline?: {
                __typename?: 'VitaDocumentCVProfessionalExperienceDiscipline';
                id?: string | null;
                value?: string | null;
              } | null;
            } | null> | null;
            educationExperience?: Array<{
              __typename?: 'VitaDocumentCVEducationExperience';
              institution?: string | null;
              startDate?: string | null;
              endDate?: string | null;
              courseOfStudy?: string | null;
              degree?: string | null;
              isStillStudy?: boolean | null;
            } | null> | null;
            skills?: Array<{
              __typename?: 'VitaDocumentCVSkill';
              skill?: string | null;
            } | null> | null;
            preferences?: {
              __typename?: 'VitaDocumentCVPreferences';
              seekingStatus?: Types.SeekingStatus | null;
              seekingReason?: Types.VitaSeekingReason | null;
              otherSeekingReason?: string | null;
              homeOffice?: boolean | null;
              targetPosition?: string | null;
              locations?: Array<{
                __typename?: 'VitaDocumentCVPreferencesLocation';
                cityId?: number | null;
                cityIdWithScrambling?: string | null;
                cityName?: string | null;
              } | null> | null;
            } | null;
          } | null;
          theme?: {
            __typename?: 'VitaDocumentTheme';
            color?: Types.VitaDocumentThemeColor | null;
            template?: Types.VitaDocumentThemeTemplate | null;
          } | null;
          fileAttachments?: {
            __typename?: 'VitaDocumentFileAttachments';
            profileImage?: {
              __typename?: 'VitaDocumentFileAttachment';
              id?: string | null;
              url?: string | null;
            } | null;
          } | null;
        }
      | { __typename?: 'VitaDocumentError' }
      | null;
  } | null;
};

export const GetVitaLatestDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetVitaLatestDocument' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vitaLatestDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VitaDocument' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaPersonalInformation' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentCVPersonalInformation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'birthdate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'birthplace' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaProfessionalExperience' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentCVProfessionalExperience' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentEmployer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'descriptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'industry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discipline' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaEducationExperience' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentCVEducationExperience' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'institution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courseOfStudy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degree' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStillStudy' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaSkill' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentCVSkill' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'skill' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaPreferences' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentCVPreferences' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'seekingStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'seekingReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherSeekingReason' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cityId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cityIdWithScrambling' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cityName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'homeOffice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'targetPosition' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaDocumentCV' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentCV' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaPersonalInformation' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalExperience' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaProfessionalExperience' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'educationExperience' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaEducationExperience' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skills' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaSkill' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'aboutMe' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaPreferences' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaDocumentTheme' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentTheme' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaDocumentProfileImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentFileAttachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaDocumentFileAttachments' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocumentFileAttachments' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaDocumentProfileImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VitaDocument' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VitaDocument' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cv' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaDocumentCV' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'theme' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaDocumentTheme' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileAttachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VitaDocumentFileAttachments' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetVitaLatestDocumentQuery,
  GetVitaLatestDocumentQueryVariables
>;
